var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("update"),
      "isDialogActive": _vm.isDialogOpen,
      "rightDisabled": !_vm.isValid,
      "rightLoading": _vm.loading,
      "hideLeft": true,
      "width": '600px',
      "persistent": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogOpen = $event;
      },
      "rightClick": function rightClick() {
        return _vm.update();
      }
    }
  }, [_c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('claim-settlement-form', {
    model: {
      value: _vm.localReport,
      callback: function callback($$v) {
        _vm.localReport = $$v;
      },
      expression: "localReport"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }